import { createSelector } from 'reselect'

import { selectPartnerSearchState } from './selectPartnerSearchState'

export const selectIsP360Search = createSelector(
  [selectPartnerSearchState],
  ({ isP360 = false }) => isP360
)
